import { render, staticRenderFns } from "./lxWatch.vue?vue&type=template&id=b032c4b0&scoped=true&"
import script from "./lxWatch.vue?vue&type=script&lang=js&"
export * from "./lxWatch.vue?vue&type=script&lang=js&"
import style0 from "./lxWatch.vue?vue&type=style&index=0&id=b032c4b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b032c4b0",
  null
  
)

export default component.exports